type PeriodOption = {
    value: string;
    label: string;
};

type PeriodSelectorProps = {
    value: string;
    onChange: (value: string) => void;
    options: PeriodOption[];
};

export const PeriodSelector = ({ value, onChange, options }: PeriodSelectorProps) => (
    <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="text-sm border border-input bg-background rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-ring"
    >
        {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
                {opt.label}
            </option>
        ))}
    </select>
);
